import React, { useEffect } from "react";
import { Button, Col, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { useDispatch } from "react-redux";
import SvgSearch from "../../Shared/Icons/bootstrap/Search";
import SvgWallet from "../../Shared/Icons/bootstrap/Wallet";
import { findBooking } from "./Actions";
import { useStateSelector } from "./Model";

const strings = getStrings().component.booking;

interface ISearchFields
{
	bookingNumber: string;
	email: string;
}

export const SearchForm = () => {
	const dispatch = useDispatch();

	const { register, handleSubmit, formState, setValue, watch } = useForm<ISearchFields>({ mode: "onBlur" });

	const mode = useStateSelector(state => state.manageBooking.mode);
	const bookingNumber = watch("bookingNumber");



	useEffect(() => {
		if (!window?.location.search)
			return;

		const searchParams = new URLSearchParams(window?.location.search);
		const bookingNumber = searchParams.get("orderId");
		if (bookingNumber)
			setValue("bookingNumber", bookingNumber);
		const email = searchParams.get("email");
		if (email)
			setValue("email", email);
	}, [window?.location.search]);

	const submitSearch = (data: ISearchFields) => {
		console.debug(data);
		dispatch(findBooking(data.bookingNumber, data.email, mode));
	}

	return <fieldset>
		<legend>{strings.findBookingHeader}</legend>
		<Form onSubmit={handleSubmit(submitSearch)}>
			<Form.Row>
				<Col sm={5}>
					<Form.Group controlId="bookingNumber">
						<Form.Label className="sr-only">{strings.bookingNumber}</Form.Label>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text><SvgWallet /></InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control type="text" placeholder={strings.bookingNumber}
								className={formState?.errors["bookingNumber"] ? "is-invalid" : ""}
								{...register("bookingNumber", { required: true, pattern: /^[A-Za-z0-9]{6}$/ })} />
						</InputGroup>
						{ formState.errors.bookingNumber && <Form.Text className="text-danger">{bookingNumber?.length > 6 ?	strings.bookingNumberTooLong : strings.bookingNumberInvalid}</Form.Text>}
					</Form.Group>
				</Col>
				<Col sm={5}>
					<Form.Group controlId="emailOrPhone">
						<Form.Label className="sr-only">{strings.emailOrPhone}</Form.Label>
						<InputGroup>
							<InputGroup.Prepend>
								<InputGroup.Text><SvgSearch /></InputGroup.Text>
							</InputGroup.Prepend>
							<Form.Control type="text" placeholder={strings.emailOrPhone}
								className={formState?.errors["email"] ? "is-invalid" : ""}
								{...register("email", { required: true })}/>
						</InputGroup>
					</Form.Group>
				</Col>
				<Col sm={2}>
					<Button type="submit" variant="primary">{strings.search}</Button>
				</Col>
			</Form.Row>
		</Form>
	</fieldset>;
}